<ng-container *ngIf='!accessDenied'>
    <div class="w-100 float-left">
        <div class="w-100 float-left v-align relative" *ngIf='mainPage'>
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0">PAGE-AUTHORIZATION</h5>
                <div style="flex-grow: 1;"></div>
                <!-- <button id="add" (click)="onBack()" class="btn btn-primary float-right mr-3"> Back </button> -->
            </div>
        </div>
        <ngb-tabset type="pills" activeId='{{selectedTab}}' (tabChange)="beforeChange($event)">
            <ngb-tab title="Individual" id="individual">
                <ng-template ngbTabContent="ngbTabContent">
                    <div *ngIf='mainPage' class="main-table table-custom">
                        <div class="w-100 float-left p-3 light-bg">
                            <div class="form-group">
                                <div class='col-lg-12 col-md-12 left-clear'>
                                    <label>
                                        <h5 class="medium m-0">Data Operations</h5>
                                    </label>
                                </div>
                            </div>
                            <ng-container *ngIf="!isProgress">
                                <div class="form-group">
                                    <div class='col-lg-12 col-md-12 left-clear'>
                                        <form enctype="multipart/form-data" method="POST" class="">
                                            <input type="file" accept=".xls,.xlsx"
                                                   class="pull-left next-btn r mt-smd m-r-smd m-b-smd" multipart=true
                                                   name="file" #file (change)="fileChange($event)"
                                                   placeholder="No File Chosen."/>
                                            <button id="bulkUpload" type="submit"
                                                    class="btn btn-primary float-right mr-3"
                                                    (click)="bulkUpload($event)">Bulk
                                                Upload
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="isProgress">
                                <div class="w-100 float-left p-3 light-bg">
                                    <div class="progress">
                                        <div class="progress-bar" role="progressbar" [ngStyle]="{'width':progress+ '%'}"
                                             [attr.aria-valuenow]="progress" aria-valuemin="0" aria-valuemax="100">
                                            {{progress}}%
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <!-- <employeeSearch [totalElementsPerPage]='pageSize' [selectedPage]='currentPage' (employeeList)='employeesFound($event)' (loaderEnable)='loaderControl($event)'
                                        (pageData)='pageDataControl($event)'></employeeSearch> -->
                        <div>
                            <employeeFilter [displayTab]="'employeeSearch'" (searchEmp)="showSearchFilter($event)">
                            </employeeFilter>
                        </div>
                        <div class="w-100 float-left mt-3">
                            <div class="form-group">
                                <div class='col-lg-6 col-md-6 left-clear'>
                                    <label>
                                        <h5 class="medium m-0">Select DashBoard</h5>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class='col-lg-6 col-md-6 left-clear'>
                                    <select name="pageList" class="form-control light-bg"
                                            (change)="onSelectPage($event)">
                                        <option [value]='page.id' *ngFor="let page of pageList">{{page.name}}
                                            ({{page.pageCode}})
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <!-- <div class="form-group">
                                                <div class='col-lg-6 col-md-6 left-clear'>
                                                    <label>
                                                        <h5 class="medium m-0">Page-Authorization Contents</h5>
                                                    </label>
                                                </div>
                                            </div> -->
                            <div class="w-100 mb-3 align-v-center justify-content-between">
                                <h5 class="mb-0 medium">Page-Authorization Contents</h5>
                                <div class="align-v-center">
                                    <div class="mr-3">
                                        <i class="fa fa-check-circle text-success"></i><span
                                            class="ml-2 text-14x">Active</span>
                                    </div>
                                    <div class="mr-3">
                                        <i class="fa fa-times-circle text-danger"></i><span
                                            class="ml-2 text-14x">Inactive</span>
                                    </div>
                                    <div class="mr-3">
                                        <i class="fa fa-lock"></i><span class="ml-2 text-14x">Lock</span>
                                    </div>
                                </div>
                            </div>
                            <div class="table-responsive text-nowrap"
                                 *ngIf="(empList && empList.length && empList.length > 0) && (pageSectionList && pageSectionList.length)">
                                <table class="table table-bordered table-hover table-striped">
                                    <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">
                                            <h6 class="mb-lg-0 medium"> Employee Code </h6>
                                        </th>
                                        <th scope="col">
                                            <h6 class="mb-lg-0 medium"> Employee Name </h6>
                                        </th>
                                        <th scope="col">
                                            <h6 class="mb-lg-0 medium"> Select All </h6>
                                        </th>
                                        <th *ngFor="let ps of pageSectionList" scope="col">
                                            <h6 class="mb-lg-0 medium"> {{ps.name}} ({{ps.pageSectionCode}}) </h6>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let empData of empList, let i = index">
                                        <td scope="row">
                                            <h6 class="mb-lg-0 text-truncate"> {{empData.empCode}} </h6>
                                        </td>
                                        <td scope="row">
                                            <h6 class="mb-lg-0 text-truncate"> {{empData.displayName}} </h6>
                                        </td>
                                        <td scope="row">
                                            <!-- <input type="checkbox" [attr.id]="empData.id" [(ngModel)]='selectedAll[i]' (change)="selectAll(empData.id,i)" /> -->
                                            <div ngbDropdown class="p-initial dropdown" placement="bottom-right">
                                                <a [id]="empData.id" ngbDropdownToggle>
                                                    <i class="fa"
                                                       [ngClass]="selectedAll[i] != undefined ? {'fa-check-circle text-success': selectedAll[i] == 0, 'fa-times-circle text-danger':
                                                                         selectedAll[i] == 1, 'fa-lock': selectedAll[i] == 2, 'fa-circle-o':selectedAll[i] == 3} : 'fa-circle'"></i>
                                                </a>
                                                <div ngbDropdownMenu [attr.aria-labelledby]="empData.id">
                                                    <a class="dropdown-item" (click)="selectAll(empData.id,i,0)"><i
                                                            class="fa fa-check-circle text-success mr-2"></i>Active</a>
                                                    <a class="dropdown-item" (click)="selectAll(empData.id,i,1)"><i
                                                            class="fa fa-times-circle text-danger mr-2"></i>Inactive</a>
                                                    <a class="dropdown-item" (click)="selectAll(empData.id,i,2)"><i
                                                            class="fa fa-lock mr-2"></i>Lock</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td *ngFor="let ps of pageSectionList" scope="row">
                                            <!-- <h6 class="mb-lg-0 text-truncate">
                                                                <input type="checkbox" [attr.id]="empData.id" [attr.value]="ps.id" [ngModel]="paMap.get(empData.id+'_'+ps.id)"
                                                                    (change)="onChange($event,i)" />
                                                            </h6> -->
                                            <div ngbDropdown class="p-initial dropdown" placement="bottom-right">
                                                <a [id]="empData.id+'_'+ps.id" ngbDropdownToggle>
                                                    <i class="fa"
                                                       [ngClass]="paMap.get(empData.id+'_'+ps.id) != undefined ? {'fa-check-circle text-success': paMap.get(empData.id+'_'+ps.id) == 0,
                                                                        'fa-times-circle text-danger': paMap.get(empData.id+'_'+ps.id) == 1, 'fa-lock': paMap.get(empData.id+'_'+ps.id) == 2} : 'fa-times-circle text-danger'"></i>
                                                </a>
                                                <div ngbDropdownMenu [attr.aria-labelledby]="empData.id+'_'+ps.id">
                                                    <a class="dropdown-item text-truncate"
                                                       (click)="onChange(empData.id,ps.id,i,0)"><i
                                                            class="fa fa-check-circle text-success mr-2"></i>Active</a>
                                                    <a class="dropdown-item text-truncate"
                                                       (click)="onChange(empData.id,ps.id,i,1)"><i
                                                            class="fa fa-times-circle text-danger mr-2"></i>Inactive</a>
                                                    <a class="dropdown-item text-truncate"
                                                       (click)="onChange(empData.id,ps.id,i,2)"><i
                                                            class="fa fa-lock mr-2"></i>Lock</a>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <ng-container *ngIf="!(empList && empList.length && empList.length > 0)">
                                <div class="w-100 float-left  mt-3" *ngIf="!loader">
                                    <p class="text-center m-0 w-100 medium">No Employee to Show</p>
                                </div>
                            </ng-container>
                            <ng-container
                                    *ngIf="(empList && empList.length && empList.length > 0) && !(pageSectionList && pageSectionList.length)">
                                <div class="w-100 float-left  mt-3" *ngIf="!loader">
                                    <p class="text-center m-0 w-100 medium">No Page Section to Load</p>
                                </div>
                            </ng-container>

                            <!-- PAGINATION -->
                            <div *ngIf="(pageSectionList && pageSectionList.length)"
                                 class="w-100 float-left my-4 light-bg p-3 align-v-center">
                                <h6 class="float-left mb-0 mr-4"> {{startingPage + 1}} - {{endingPage}} items of
                                    {{totalEmps}} </h6>
                                <div class="float-left ml-2 align-v-center">
                                    <label class="m-0 float-left">Show items per page</label>
                                    <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="pageSize"
                                            (change)="OnPageSizeChanged($event)">
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                    </select>
                                </div>
                                <div style="flex-grow: 1;"></div>
                                <ngb-pagination [collectionSize]="totalEmps" [rotate]="true" [pageSize]="pageSize"
                                                [ellipses]="false" [maxSize]="5" [boundaryLinks]="true"
                                                [(page)]="currentPage"
                                                (pageChange)="onPageChange($event)"
                                                class="float-right"></ngb-pagination>
                            </div>

                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left mt-3">
                                <button id="onSaveChanges" type="submit" class="float-right btn btn-primary"
                                        (click)="onSaveChanges($event)" [disabled]="!saveChangesButton">Save
                                    Changes
                                </button>
                            </div>

                            <!-- Bulk Upload-->
                            <div class='info' *ngIf='uploadSucess'>
                                <div class='col-lg-6 col-md-6 left-clear'>
                                    <label>
                                        <h5 class="medium m-0">Bulk Upload Summary</h5>
                                    </label>
                                </div>
                                <div class="light-bg w-100 float-left p-2 grid-details">
                                    <!-- <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                                <h6 class="mb-lg-0 medium"> UPLOADED DATA </h6>
                                                            </div> -->
                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                        <h6 class="mb-lg-0 medium"> NON EXISTENT USERS </h6>
                                    </div>
                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                        <h6 class="mb-lg-0 medium"> NON EXISTENT PAGE SECTIONS </h6>
                                    </div>
                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                        <h6 class="mb-lg-0 medium"> NON EXISTENT ACCESS </h6>
                                    </div>
                                    <!-- <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center">
                                                        <h6 class="mb-lg-0 medium"> REMOVED DATA </h6>
                                                    </div> -->
                                </div>
                                <div class="light-bg w-100 float-left p-2 grid-details">
                                    <!-- <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                                                <ul>
                                                                    <li *ngFor="let paData of uploadedDataList">{{paData.id}} , {{paData.userId}} , {{paData.pageSectionId}}</li>
                                                                </ul>
                                                            </div> -->
                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                        <ul>
                                            <li *ngFor="let data of nonExistentUsers">{{data}}</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                        <ul>
                                            <li *ngFor="let data of nonExistentPageSections">{{data}}</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                        <ul>
                                            <li *ngFor="let data of nonExistentAccess">{{data}}</li>
                                        </ul>
                                    </div>
                                    <!-- <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center">
                                                        <ul>
                                                            <li *ngFor="let data of removedDataList">{{data}}</li>
                                                        </ul>
                                                    </div> -->
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left mt-3">
                                    <button id="onSaveChanges" type="submit" class="float-right btn btn-primary"
                                            (click)="onCloseSummary($event)">Close
                                        Summary
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ngb-tab>
            <ngb-tab title="Bulk" id="bulk">
                <ng-template ngbTabContent="ngbTabContent">
                    <div class="w-100 float-left mb-4 b-b">
                        <div class="row">
                            <div class="col-lg-8 col-md-8">
                                <div class="form-group align-v-center">
                                    <label class="medium col-4" for="excelTypeSelect">
                                        Browse File To Upload:
                                        <span class="text-danger medium">*</span>
                                    </label>
                                    <div class="relative">
                                        <input type="file" accept=".xlsx" class="fileInput" multipart=true name="file"
                                               #file (change)="chooseFile($event)" placeholder="No File Chosen."/>
                                        <button class="btn btn-primary ml-3">Browse</button>
                                    </div>
                                    <label class="mb-0 ml-2" *ngIf="fileNameToUpload != null">
                                        {{fileNameToUpload}}</label>
                                </div>
                                <ng-container *ngIf="fileNameToUpload != null">
                                    <div class="form-group w-100 float-left align-v-center">
                                        <label class="medium col-4" for="comments">
                                            Comments:
                                            <span class="text-danger medium">*</span>
                                        </label>
                                        <textarea class="form-control col-6 ml-3" rows="2"
                                                  name="comment" [(ngModel)]="comment" placeholder="Enter Comments"
                                                  required></textarea>
                                    </div>
                                    <div class="form-group w-100 float-left align-v-center">
                                        <label class="medium col-4"></label>
                                        <button id="bulkUpload" type="submit" class="btn btn-primary ml-3"
                                                (click)="initBulkPageAuth($event)">
                                            Upload
                                        </button>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <div class="form-group align-v-center">
                                    <a href='javascript:void(0)' class="" (click)="downloadTemplate()">Download
                                        Template</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="w-100 float-left mb-4" *ngIf="tableData.length > 0">
                        <div class="w-100 float-left align-v-center mb-3">
                            <div style="flex-grow: 1;"></div>
                            <button class="btn btn-primary float-right" name="pageAuthHistoryRefresh"
                                    (click)="getPageAuthHistory()" [disabled]="uploadButtonDisable">
                                <i class="fa fa-refresh mr-2 text-white"></i> Refresh
                            </button>
                        </div>
                        <div class="col-lg-12 col-md-12 float-left">
                            <div class="light-bg w-100 p-2 grid-details">
                                <div class="col-2">
                                    <h6 class="mb-0 medium">Comments</h6>
                                </div>
                                <div class="col-2">
                                    <h6 class="mb-0 medium">Start Date</h6>
                                </div>
                                <div class="col-2">
                                    <h6 class="mb-0 medium">Status</h6>
                                </div>
                                <div class="col-2">
                                    <h6 class="mb-0 medium">Failure Reason</h6>
                                </div>
                                <div class="col-2">
                                    <h6 class="mb-0 medium">Attached File</h6>
                                </div>
                                <div class="col-2">
                                    <h6 class="mb-0 medium">Response File</h6>
                                </div>
                            </div>
                            <ng-container>
                                <div class="w-100 p-2 grid-details" *ngFor="let data of tableData">
                                    <div class="col-2">
                                        <h6 class="mb-0">{{data.comment}} </h6>
                                    </div>
                                    <div class="col-2">
                                        <h6 class="mb-0">{{data.startDate}}</h6>
                                    </div>
                                    <div class="col-2">
                                        <h6 class="mb-0">{{data.state}}</h6>
                                    </div>
                                    <div class="col-2">
                                        <h6 class="mb-0">{{data.failureReason}}</h6>
                                    </div>
                                    <div class="col-2">
                                        <a href="#/biAdmin/pageAuthorization" class="mb-0 small"
                                           *ngIf="data.attachedFiles.length > 0" ngbTooltip="{{'clickToDownload'}}"
                                           (click)="downloadPageAuthFiles(data.attachedFiles[0].filePath)">{{data.attachedFiles[0].name}}
                                        </a>
                                    </div>
                                    <div class="col-2">
                                        <a href="#/biAdmin/pageAuthorization" class="mb-0 small"
                                           *ngIf="data.attachedFiles.length > 1" ngbTooltip="{{'clickToDownload'}}"
                                           (click)="downloadPageAuthFiles(data.attachedFiles[1].filePath)">{{data.attachedFiles[1].name}}
                                        </a>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <!-- PAGINATION -->
                        <div class="w-100 float-left my-4 light-bg p-3 align-v-center">
                            <h6 class="float-left mb-0 mr-4 text-truncate"> {{authStartingPage}} - {{authEndingPage}} of
                                {{authTotalRecs}}
                                items </h6>
                            <div class="float-left ml-2 align-v-center">
                                <label class="m-0 float-left">Show items per page</label>
                                <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="authPageSize"
                                        (change)="onAuthHistoryPageSizeChanged($event)">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                </select>
                            </div>
                            <div style="flex-grow: 1;"></div>
                            <ngb-pagination *ngIf='tableData && tableData.length' [collectionSize]="authTotalRecs"
                                            [rotate]="true"
                                            [maxSize]="5" [pageSize]="authPageSize" [ellipses]="false"
                                            [boundaryLinks]="true" [(page)]="authCurrentPage"
                                            (pageChange)="onAuthHistoryPageChange($event)"
                                            class="float-right"></ngb-pagination>
                        </div>
                    </div>
                </ng-template>
            </ngb-tab>
        </ngb-tabset>

    </div>
    <div class="w-100 min-h2 relative" *ngIf="loader">
        <loader></loader>
    </div>
</ng-container>


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/pageAuthorization.component.html